export interface LineContactInfo {
  line?: string
  lineUrl?: string
}

/** Resolve LINE link from tenant content — prefer admin-configured lineUrl. */
export function resolveLineContactHref(contactInfo?: LineContactInfo | null): string | null {
  const lineUrl = contactInfo?.lineUrl?.trim()
  if (lineUrl) return lineUrl

  const lineId = contactInfo?.line?.trim()
  if (!lineId) return null
  if (lineId.startsWith('http://') || lineId.startsWith('https://')) return lineId

  return lineId.startsWith('@')
    ? `https://line.me/ti/p/${lineId}`
    : `https://line.me/ti/p/@${lineId}`
}

export function resolveLineContactId(contactInfo?: LineContactInfo | null, fallback = '@hauytoday'): string {
  return contactInfo?.line?.trim() || fallback
}
